"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var LeftArrow = function LeftArrow() {
  return React.createElement("svg", {
    className: 'arrow',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 27 44'
  }, React.createElement("path", {
    d: 'M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z'
  }));
};
exports.LeftArrow = LeftArrow;